import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const postBusSchedule = ({ bus_course_id, ...data }) => {
  return api.post(`/admin/bus-courses-v2/${bus_course_id}/schedules`, data);
};

export const usePostBusScheduleMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: postBusSchedule,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
};
